module.exports = __webpack_public_path__ + "static/media/homeBanner.6993ec84.jpeg";